import React, {Component} from 'react';
import Button from './Button';
import styled from 'styled-components/macro'

const Icon = styled.svg`
  width: 28px;
  height: 28px;
  margin: 8px;
  fill: ${({theme}) => theme.bg};
`

const RulerOn = props =>(
  <Icon viewBox="0 0 24 24">
    <path d="M20,4V20H4V4H20m0-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2Z"/>
  </Icon>
)

const RulerOff = props =>(
  <Icon viewBox="0 0 24 24">
    <g>
      <path d="M20,4V17.8789l2,2V4a2,2,0,0,0-2-2H4.1211l2,2Z"/>
      <path d="M22.6191,22.3809l-21-21L.3813,2.6187,2,4.2374V20a2,2,0,0,0,2,2H19.7618l1.6191,1.6191ZM4,20V6.2375L17.7619,20Z"/>
    </g>
  </Icon>
)

class Ruler extends Component {
  render(){
    let {handleClick, ruler} = this.props;
    return (
      <Button onClick={handleClick}>
        { ruler ?
          <RulerOff /> :
          <RulerOn />
        }
      </Button>
    )
  }
}

export default Ruler;